export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/reading_eggs-96e503baaf33e63dbc39d0371e3fbbee.svg";